<style lang="scss" scoped>


</style>

<template>
    <div v-if="false" class="container-xl">
        <!-- Page title -->
        <div class="page-header d-print-none">
            <div class="row align-items-center">
                <div class="col">
                    <h2 class="page-title">
                        <slot name="page-title">Seitentitel</slot>
                    </h2>
                </div>
            </div>
        </div>
    </div>
    <div class="page-body">
        <div class="container-xl">
			<slot></slot>
            <slot name="page-back">
                <div class="row mt-3">
                    <div class="col-6 col-sm-4 col-md-2 col-xl-auto mb-3">
                        <a href="#" @click="$router.go(-1)" class="btn btn-light" style="color:#626976">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-back-up text-blue" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="#626976" fill="none" stroke-linecap="round" stroke-linejoin="round">
                              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                              <path d="M9 13l-4 -4l4 -4m-4 4h11a4 4 0 0 1 0 8h-1" />
                            </svg>
                            Zurück
                        </a>
                    </div>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>


export default {
  name: 'Content'
}

</script>
